module.exports = __webpack_public_path__ + "img/transgender-black-18dp.5c513f49.svg";